import { z } from '@/libs/zod';

export const prizeScratchedSchema = z.object({
  name: z.string().nullable(),
  type: z.string().nullable(),
  isDrawn: z.boolean().nullable(),
  prizeUrls: z.string().nullable(),
  prizeValue: z.number().nullable(),
});

export const ticketToScratchSchema = z.object({
  sequence: z.string(),
  winning: z.boolean(),
  prizes: z.array(prizeScratchedSchema),
  date: z.string(),
  id: z.string(),
  hasBeenScratched: z.boolean(),
});

export const setScratchedRequestSchema = z
  .object({
    allTicketsToScratch: z.array(ticketToScratchSchema).optional(),
    scratchAllRaffleTickets: z.boolean().optional(),
    raffleId: z.string().optional(),
  })
  .refine(
    (data) => !(!data.allTicketsToScratch?.length && !data.scratchAllRaffleTickets),
    {
      message:
        'Pelo menos um bilhete deve ser fornecido ou todas as bilhetes devem ser marcados para raspar',
      path: ['allTicketsToScratch', 'scratchAllRaffleTickets'],
    },
  )
  .refine((data) => !(data.scratchAllRaffleTickets && !data.raffleId), {
    message:
      'O ID do sorteio é obrigatório quando todas as bilhetes são marcados para raspar',
    path: ['raffleId'],
  });

export const scratchedPrizeSchema = z.object({
  id: z.string(),
  name: z.string(),
  prizeValue: z.number(),
  credited: z.boolean(),
});

export const setScratchedResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  totalPrizeValue: z.number().optional(),
  prizes: z.array(scratchedPrizeSchema).optional(),
  scratchedCount: z.number().optional(),
});

export type PrizeScratched = z.infer<typeof prizeScratchedSchema>;
export type ScratchedPrize = z.infer<typeof scratchedPrizeSchema>;
export type TicketToScratch = z.infer<typeof ticketToScratchSchema>;
export type SetScratchedRequest = z.infer<typeof setScratchedRequestSchema>;
export type SetScratchedResponse = z.infer<typeof setScratchedResponseSchema>;

export type SetScratchedParams = {
  cpf: string;
  phone: string;
};
